import { Dispatch, useEffect } from 'react';
import { useSticky } from 'react-table-sticky';
import { useFlexLayout, useTable } from 'react-table';

import { IStoredTable } from 'types/redux/tep';
import { IColumnSortingInfo, ITableColumn } from 'types/table';

interface IUseTableHookProps {
  isLoading: boolean;
  columns: ITableColumn[];
  data: Record<string, unknown>[];
  selectedRowIds?: string[];
  clickedRowId?: string;
  hiddenColumnsIds?: string[];
  columnsSorting?: IColumnSortingInfo[];
  sortColumnData?: Dispatch<IColumnSortingInfo>;
  storeTable?: Dispatch<{ table: IStoredTable }>;
  onRowClick?: Dispatch<any>;
}

export const useTableHook = (props: IUseTableHookProps) => {
  const { isLoading, columns, data, hiddenColumnsIds, columnsSorting, sortColumnData, storeTable, ...rest } = props;

  const getRowId = (row: Record<string, unknown>, relativeIndex: number) => String(row?.id ? row.id : relativeIndex);

  const defaultColumn = { width: 150 };
  const initialState = { hiddenColumns: [...(hiddenColumnsIds || [])] };
  const tableOptions = {
    columns,
    data,
    defaultColumn,
    autoResetSelectedRows: false,
    initialState,
    getRowId,
  };

  const tableHooks = [useFlexLayout, useSticky];
  const tableMethods = useTable(tableOptions, ...tableHooks);

  const { getTableProps, getTableBodyProps, headerGroups, rows, columns: allColumns, prepareRow } = tableMethods;

  useEffect(() => {
    if (storeTable) {
      storeTable({ table: { allColumns } });
    }
  }, []);

  const contentProps = { isLoading, data, rows, prepareRow, getTableBodyProps, ...rest };
  const headerProps = { headerGroups, columnsSorting, sortColumnData };

  return { headerProps, contentProps, getTableProps };
};
